import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import styles from './fileUploadContainer.module.scss';
import { WithSpinner, TableAdmin, TableRow, TableCell } from '../../components';
import { actions } from './../../state/actions';
import { Api } from './../../api/api';
import { config } from './../../api/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { checkBOPage } from '../../utils/helpers/helpers';

const PaymentDocumentFileUploadContainer = ({
  dispatch,
  viewWindow,
  status,
  saveDataOnUploadCallback,
  saveDataAfterUpload,
  data,
  paymentRequestStatus,
  actionType,
}) => {
  const selectFile = (id) => {
    if (
      !saveDataAfterUpload ||
      (saveDataAfterUpload && saveDataOnUploadCallback('validateInputs'))
    ) {
      document.getElementById(id).click();
    }
  };

  const [isLoading, setIsloading] = useState(false);

  const gotoBottom = () => {
    window.scrollTo(0, document.body.scrollHeight);
  };

  const upload = (e) => {
    setIsloading(true);
    const file = e.target.files[0];
    if (file.size > 20 * 1048 * 1048) {
      setIsloading(false);
      swal({
        title: 'Įkeliamas priedas viršija 20mb leistiną limitą',
        icon: 'error',
        buttons: {
          confirm: {
            text: 'Gerai',
            value: true,
            visible: true,
            className: 'btn btn-pink',
            closeModal: true,
          },
        },
      });
    } else {
      const formData = new FormData();
      formData.append('Files', file);
      formData.append('RelatedId', data.Id);
      formData.append(null, data.DocumentType); //irasyta tuscia reiksme
      fetch(Api.API_BASE_URL + config.API_ENDPOINTS.UploadFilesPrd, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
        },
        body: formData,
      })
        .then((res) => {
          if (res.ok === true) {
            if (saveDataAfterUpload) {
              saveDataOnUploadCallback('save');
            } else {
              if (data.PaymentRequestId) {
                dispatch(
                  actions.dashboard.createNewPaymentRequestPrDocumentAction(
                    data.PaymentRequestId,
                    data.Id,
                    'edit',
                    data?.Number || ''
                  )
                );
              }
            }

            swal({
              title: `Priedas sėkmingai įkeltas${
                saveDataAfterUpload ? ' ir išsaugotas dokumentas' : ''
              }`,
              icon: 'success',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn btn-pink',
                  closeModal: true,
                },
              },
            });
          } else if (res.status === 403) {
            swal({
              title: `Šiam veiksmui atlikti neturite reikiamų teisių. Kreipkitės į sistemos administratorių`,
              icon: 'error',
              buttons: {
                confirm: {
                  text: 'Gerai',
                  value: true,
                  visible: true,
                  className: 'btn swal-ok-btn',
                  closeModal: true,
                },
              },
            });
          } else {
            res.json().then((r) => {
              let title = 'Nepavyko pateikti priedo';
              if (r?.errors?.RequestId) {
                title = r.errors.RequestId[0];
              } else if (r.errors) {
                title = r.errors['Files[0].FileName'][0];
              } else if (r.ErrorDescription) {
                title = r.ErrorDescription;
              }
              swal({
                title: title,
                icon: 'error',
                buttons: {
                  confirm: {
                    text: 'Gerai',
                    value: true,
                    visible: true,
                    className: 'btn swal-ok-btn',
                    closeModal: true,
                  },
                },
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsloading(false);
          setTimeout(() => {
            gotoBottom();
          }, 2000);
        });
      //  dispatch(actions.dashboard.fileUploadAction(formData, 'upload'));
    }
  };

  const tableHeader = ['Įkelto priedo pavadinimas', 'Veiksmai'];

  const deleteConfirmation = (invoiceId, fileId) => {
    swal({
      title: 'Ar tikrai norite ištrinti šį failą?',
      icon: 'warning',
      showCancelButton: true,

      buttons: {
        confirm: {
          text: 'Taip',
          value: true,
          visible: true,
          className: 'btn swal-ok-btn',
          closeModal: true,
        },
        cancel: {
          text: 'Ne',
          value: false,
          visible: true,
          className: 'btn btn-primary',
          closeModal: true,
        },
      },
    }).then((result) => {
      if (result) {
        deleteFile(invoiceId, fileId);
      }
    });
  };

  const downloadRejectionFile = (invoiceId, fileId, fileName) => {
    const path = window.location.pathname?.split('/')?.[1];

    setIsloading(true);
    fetch(
      Api.API_BASE_URL +
        config.API_ENDPOINTS.DownloadFilePrd(invoiceId, fileId),
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            path === 'backoffice' ? 'token' : 'userToken'
          )}`,
        },
      }
    )
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .finally(() => {
        setIsloading(false);
      });
  };

  const deleteFile = (invoiceId, fileId) => {
    setIsloading(true);
    fetch(
      Api.API_BASE_URL +
        config.API_ENDPOINTS.DeleteUploadedFilePrd(invoiceId, fileId),
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('userToken')}`,
        },
      }
    )
      .then((res) => {
        if (res.ok === true) {
          if (data.PaymentRequestId) {
            dispatch(
              actions.dashboard.createNewPaymentRequestPrDocumentAction(
                data.PaymentRequestId,
                data.Id,
                'edit',
                data?.Number || ''
              )
            );
          }

          swal({
            title: 'Priedas sėkmingai ištrintas',
            icon: 'success',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn btn-pink',
                closeModal: true,
              },
            },
          });
        } else {
          swal({
            title: 'Nepavyko pašalinti priedo',
            icon: 'error',
            buttons: {
              confirm: {
                text: 'Gerai',
                value: true,
                visible: true,
                className: 'btn swal-ok-btn',
                closeModal: true,
              },
            },
          });
        }
      })
      .catch((err) => {
        console.log('catch block');
        console.log(err);
      })
      .finally(() => {
        setIsloading(false);
        setTimeout(() => {
          gotoBottom();
        }, 2000);
      });
  };

  return (
    <WithSpinner loading={isLoading}>
      <div className={styles.container}>
        <h4>
          {!data?.IsApproved &&
          (paymentRequestStatus === 1 || paymentRequestStatus === 3) &&
          !checkBOPage() &&
          actionType !== 'view'
            ? 'Priedų įkėlimas'
            : 'Priedai'}
        </h4>
        <div className={styles.container}>
          {data.Files != null && data.Files.length > 0 ? (
            <>
              <TableAdmin header={tableHeader} isEmpty={false}>
                {data.Files.map(({ Id, Name, Type }) => (
                  <TableRow key={Id}>
                    <TableCell>{Name}</TableCell>
                    <TableCell>
                      <div className={styles.iconsContainer}>
                        {!data?.IsApproved &&
                          (paymentRequestStatus === 1 ||
                            paymentRequestStatus === 3) &&
                          actionType !== 'view' && (
                            <FontAwesomeIcon
                              icon={faTrash}
                              className={styles.iconPointer}
                              onClick={() => deleteConfirmation(data.Id, Id)}
                              style={{
                                color: '#597a96',
                              }}
                            />
                          )}

                        <FontAwesomeIcon
                          icon={faDownload}
                          className={styles.iconPointer}
                          onClick={() =>
                            downloadRejectionFile(data.Id, Id, Name)
                          }
                          style={{
                            color: '#597a96',
                          }}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableAdmin>
            </>
          ) : (
            <p className="nofileText">Nėra įkeltų priedų</p>
          )}
          {!data?.IsApproved &&
            (paymentRequestStatus === 1 || paymentRequestStatus === 3) &&
            !checkBOPage() &&
            actionType !== 'view' && (
              <>
                <div style={{ display: 'flex' }}>
                  <span
                    className={styles.disabled}
                    style={{
                      width: '155px',
                      marginTop: '-5px',
                      marginLeft: '10px',
                    }}
                  >
                    <span className={styles.textUptheButton}>
                      Pasirinkti priedą
                    </span>

                    <button
                      className={'btn ui-button btn-dark-blue-standart'}
                      type="longBtn"
                      onClick={() => selectFile('fileElem')}
                      style={{ marginTop: '9px', padding: '9px' }}
                    >
                      PASIRINKTI PRIEDĄ
                    </button>
                    <input
                      type="file"
                      id="fileElem"
                      accept={
                        '.docx, .xlsx, .doc, .xls, adoc, .pdf, .jpeg, .png, .jpg'
                      }
                      className="d-none"
                      onChange={upload}
                    />
                  </span>
                </div>
              </>
            )}
        </div>
      </div>
    </WithSpinner>
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboardState.isOnSync,
  filesTableList: state.dashboardState.filesTableList,
});

export default connect(mapStateToProps)(PaymentDocumentFileUploadContainer);
